module.exports = __webpack_public_path__ + "media/images/logo-9d1f174b3736a6a9d4948c3d6115d8ef.svg";